//
//
//
//
//
//

// import "../node_modules/bootstrap/dist/css/bootstrap.css";
import CommonHeader from '~/components/CommonHeader';
import 'vue2-animate/dist/vue2-animate.min.css';
import '~/assets/css/jquery.fullpage.css';
export default {
  components: {
    CommonHeader: CommonHeader
  },
  created: function created() {
    console.log(this.$route);
    if (this.$route.query.lang) {
      this.$store.state.lang = this.$route.query.lang;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/default.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/default.vue
// module chunks = 15